import React from "react";
import PracticeExclusion from "../../../components/PracticeExclusion/PracticeExclusion";
const PracticeExclusionPage = () => {
  return <PracticeExclusion />;
};

export default PracticeExclusionPage;
